import * as React from "react";
import { PropertyReviews } from "@shared-ui/lodging-reviews";
import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { ComponentProps, FTNodeOptions } from "typings/flexFramework/FlexComponent";
import { PropertyFilteredReviewsDialog } from "components/shared/PropertyFilteredReviewsDialog/PropertyFilteredReviewsDialog";
import { RefTarget } from "@shared-ui/ref-context";
import { UitkSpacing } from "uitk-react-spacing";
import { useDialog } from "@shared-ui/dialog-context";
import { normalizeOptionsData } from "src/components/flexFramework/FlexTemplateNode";
import { withStores } from "stores";
import { FlexModuleModelStore } from "stores/FlexModuleModelStore";

const DEFAULT_NUMBER_OF_REVIEWS = 50;

interface PropertyReviewsWrapperOptions extends FTNodeOptions {
  numberOfReviews?: number;
  includeRecentReviews?: boolean;
  hideManagementResponse?: boolean;
}

export interface PropertyReviewsProps extends ComponentProps {
  flexModuleModelStore: FlexModuleModelStore;
}

const WrappedPropertyReviews = PropertyBexApiWrapper(PropertyReviews);

export const PropertyReviewsWrapper: React.FC<PropertyReviewsProps> = ({
  flexModuleModelStore,
  context,
  flexTemplateNode,
}) => {
  const id = flexTemplateNode?.id || "";
  const [, dialogActions, DialogComponent] = useDialog(`reviews-${id}`);

  if (!flexTemplateNode) {
    return null;
  }

  const model = flexModuleModelStore?.getModel(id);
  const options = normalizeOptionsData(flexTemplateNode, model) as PropertyReviewsWrapperOptions;

  const additionalInputs = {
    pagination: {
      size: options.numberOfReviews || DEFAULT_NUMBER_OF_REVIEWS,
    },
    includeRecentReviews: options.includeRecentReviews || false,
    searchCriteria: {
      primary: {
        dateRange: null,
        rooms: [{ adults: 2 }],
        destination: {
          regionId: String(context?.searchContext?.location?.parent?.id),
        },
      },
    },
  };

  return (
    <>
      <UitkSpacing margin={{ block: "three" }}>
        <RefTarget name="Reviews" tag="section">
          <WrappedPropertyReviews
            additionalInputs={additionalInputs}
            context={context}
            onClickLink={dialogActions.openDialog}
            hideManagementResponse={options.hideManagementResponse}
          />
        </RefTarget>
      </UitkSpacing>
      <DialogComponent>
        <PropertyFilteredReviewsDialog context={context} onClose={dialogActions.closeDialog} />
      </DialogComponent>
    </>
  );
};

export default withStores("flexModuleModelStore")(PropertyReviewsWrapper);
